<template>
    <div class="general-update-info ut-card-base">
        <div class="oa-badge">
          <img src="@/assets/styles/frontend-library/images/openagent-mark-white.svg" />
        </div>
        <div class="consultant-name-info">
          <div class="consultant-img">
            <figure>
              <img :src="image" alt="">
            </figure>
          </div>
          <div class="ut-ml-0">
            <h2 class="ut-text-base ut-mb-1 ut-font-bold">{{ name }}</h2>
            <p class="ut-text-base ut-opacity-75">Agent Support</p>
          </div>
        </div>
        <ul>
          <li>
            <click-to-show :email="false"
                           :str="phone"
                           :formate="true"
                           :isvendor="false"
                           class="md:ut--mr-8" />
          </li>
          <li>
            <click-to-show :email="true"
                           :str="email"
                           :formate="true"
                           :isvendor="false"
                            class="md:ut--mr-8" />
          </li>
        </ul>
    </div>
</template>

<script>
import ClickToShow from '@/components/ClickToShow.vue';


export default {
  name: 'GeneralUpdateConsultantInfo',
  components: {
    ClickToShow,
  },
  props: {
    name: {
      required: true,
      type: String,
    },
    image: {
      required: false,
      type: String,
    },
    phone: {
      required: false,
      type: String || Number,
    },
    email: {
      required: true,
      type: String,
    },
  },
  data() {
    return {

    };
  },
  methods: {

  },
};

</script>

<style lang="scss" scoped>

    .general-update-info {
      min-height: 296px;
      @apply ut-pb-0 ut-relative;

      .oa-badge {
        @apply ut-absolute ut-top-0 ut-right-0 ut--mt-1 ut-mr-6 ut-bg-green-400 ut-text-center ut-pt-3;
        width: 25px;
        height: 35px;

        img{
          width: 15px;
        }

        &:after {
          content: '';
          border-right: 25px solid theme('colors.green.400');
          border-bottom: 7px solid transparent;
          position: absolute;
          right: 0;
          top: 35px;
        }

      }


      .consultant-name-info{
        @apply ut-flex ut-content-center ut-mt-1;

        .consultant-img {
          @apply ut-rounded-full ut-overflow-hidden ut-flex ut-flex-shrink-0 ut-ml-0;
          @apply ut-items-center ut-content-center ut-text-center ut-mr-4;
          @apply ut-border-2 ut-border-green-400;
          height: 77px;
          width: 77px;

          figure {
            @apply ut-rounded-full ut-overflow-hidden ut-m-auto ut-flex;
            @apply ut-flex-shrink-0 ut-items-center ut-content-center;
            width: 64px;
            height: 64px;
            background-color: #E6E5E3;
          }
        }

      }

    ul {
      @apply ut-mt-8;

      li {
      border-top: 1px solid #E6E5E3;
      @apply ut-py-6 ut-content-center ut-items-center ut-relative;
      color: #545352;
      font-size: 16px;
      line-height: 24px;
      @apply ut-pr-8;


      &:after{
        @apply ut-absolute ut-right-0;
        content: url('../assets/styles/frontend-library/images/chevron-right.svg');
      }


      }
    }

  }

</style>
